module.exports = __webpack_public_path__ + "media/luxury-2026/estate-twilight-drone-5f71dea9.jpg";